module.exports = __webpack_public_path__ + "static/device_watch_apple_dark-87382d840ec1c29e975af7dd86116d4c.png";